import{internal_serializeStyles as t}from"../../styled-engine/index.js";function e(e){const{variants:s,...n}=e,o={variants:s,style:t(n),isProcessed:!0};return o.style===n||s&&s.forEach((e=>{"function"!=typeof e.style&&(e.style=t(e.style))})),o}export{e as default};
//# sourceMappingURL=preprocessStyles.js.map
